module.exports = __webpack_public_path__ + "static/media/PG.fdf95089.png";